let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3Y3Yp")).then(() => parcelRequire('lCrzH'));